// auth.js
export const SET = 'SET'; // Define SET mutation

export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'

export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

export const FETCH_PROMOTER = 'FETCH_PROMOTER'
export const FETCH_PROMOTER_SUCCESS = 'FETCH_PROMOTER_SUCCESS'
export const FETCH_PROMOTER_FAILURE = 'FETCH_PROMOTER_FAILURE'
export const UPDATE_PROMOTER = 'UPDATE_PROMOTER'

export const FETCH_TOKYO = 'FETCH_TOKYO'
export const FETCH_TOKYO_SUCCESS = 'FETCH_TOKYO_SUCCESS'
export const FETCH_TOKYO_FAILURE = 'FETCH_TOKYO_FAILURE'
export const UPDATE_TOKYO = 'UPDATE_TOKYO'

export const SET_SHIPPING = 'SET_SHIPPING'
export const SET_CITY = 'SET_CITY'
export const SET_PACK = 'SET_PACK'
export const SET_FILE = 'SET_FILE'
export const SET_MOBILE = 'SET_MOBILE'
export const SET_WEEK = 'SET_WEEK'
export const SET_COMPLETE = 'SET_COMPLETE'
export const SET_LEAFLET = 'SET_LEAFLET'
export const SET_TRU = 'SET_TRU'
export const SET_GIFT = 'SET_GIFT'
export const SET_GIFTTYPE = 'SET_GIFTTYPE'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_CHANGE_LOCATION = 'SET_CHANGE_LOCATION'

export const SET_QRCODE = 'SET_QRCODE'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'
